// src/components/Loading.js
import React from 'react';
import { Box, CircularProgress, Typography, Fade } from '@mui/material';

const Loading = () => (
  <Fade in timeout={500}>
    <Box
      sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100vw',
        height: '100vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: 'rgba(0, 0, 0, 0.7)', // Semi-transparent overlay
        zIndex: 9999,
      }}
    >
      <CircularProgress
        size={60}
        thickness={4}
        sx={{
          color: 'primary.main',
          animation: 'spin 1.5s linear infinite, glow 1.5s ease-in-out infinite',
          '@keyframes spin': {
            '0%': { transform: 'rotate(0deg)' },
            '100%': { transform: 'rotate(360deg)' },
          },
          '@keyframes glow': {
            '0%': { filter: 'drop-shadow(0 0 2px primary.main)' },
            '50%': { filter: 'drop-shadow(0 0 10px primary.main)' },
            '100%': { filter: 'drop-shadow(0 0 2px primary.main)' },
          },
        }}
      />
      <Typography
        variant="h6"
        sx={{
          mt: 2,
          color: 'white',
          fontWeight: 500,
          animation: 'pulse 2s ease-in-out infinite',
          '@keyframes pulse': {
            '0%': { opacity: 0.6 },
            '50%': { opacity: 1 },
            '100%': { opacity: 0.6 },
          },
        }}
      >
        Loading Traders Journal...
      </Typography>
    </Box>
  </Fade>
);

export default Loading;